//+++++++++++++++++++++++++++++++++++++++++++++++
// SCROLL TO
//+++++++++++++++++++++++++++++++++++++++++++++++
// JS Scroll To functionality. Can be used
// for scroll top etc.
//+++++++++++++++++++++++++++++++++++++++++++++++

DW.scrollTo = function(to, callback, duration) {
  // because it's so fucking difficult to detect the scrolling element, just move them all
  function move(amount) {
    document.documentElement.scrollTop = amount;
    document.body.parentNode.scrollTop = amount;
    document.body.scrollTop = amount;
  }

  function position() {
    return document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop;
  }

  var fps = 60;
  var increment = 1000 / fps;

  var animate = new DW.Animate(duration, 1000 / fps, 'easeInOutQuad', position(), to - position(), move, callback );
};

//+++++++++++++++++++++++++++++++++++++++++++++++
// BACK TO TOP
//+++++++++++++++++++++++++++++++++++++++++++++++
// This class just scrolls the content
// back to top
//+++++++++++++++++++++++++++++++++++++++++++++++

/*
CC.BackToTop = function(button) {
  this.button = button;
  this.button.addEventListener('click', this.backToTopClicked);
};

CC.BackToTop.prototype.backToTopClicked = function(ev) {
  ev.preventDefault();
  CC.scrollTo(0, null, 500);
  ev.target.blur();
}*/
